import { SolidViewLayoutManager } from "@solidstarters/solid-core-ui";
let bondOption: Record<string, any> = {}; 
const bondTransactionTypeHandler = async (event: any) => {
    const { modifiedField, modifiedFieldValue, viewMetadata, } = event;
    bondOption[modifiedField] = modifiedFieldValue?.value;

    const layout = viewMetadata.layout;
    const layoutManager = new SolidViewLayoutManager(layout);
    const newFormData: any = {};
    if (bondOption?.line && bondOption?.location) {
        const whereClause = `&filters[line][$eq]=${bondOption?.line}&filters[location][$eq]=${bondOption?.location}&filters[status][$eq]=Active`
        // layoutManager.updateNodeAttributes('bond', { "whereClause": whereClause});
        const bondWhereClause = {
            line: { $eq: bondOption?.line },
            location: { $eq: bondOption?.location },
            status: { $eq: 'Active' },
          };
          
          layoutManager.updateNodeAttributes('bond', {
            whereClause: JSON.stringify(bondWhereClause),
          });
          
    }
    if (bondOption?.type) {
        if (bondOption?.type === "Import") {
            layoutManager.updateNodeAttributes('pcNo', { "visible": false});
            layoutManager.updateNodeAttributes('pcDate', { "visible": false});
            layoutManager.updateNodeAttributes('igmNo', { "visible": true});
            layoutManager.updateNodeAttributes('igmDate', { "visible": true});
            // newFormData.vessel = null;
            // newFormData.terminal = null;
            // newFormData.igmNo = null;
            // newFormData.igmDate = null;
            // newFormData.pcNo = null;
            // newFormData.pcDate = null;
        } 
         if(bondOption?.type === "Export"){
            layoutManager.updateNodeAttributes('igmNo', { "visible": false});
            layoutManager.updateNodeAttributes('igmDate', { "visible": false});
            layoutManager.updateNodeAttributes('pcNo', { "visible": true});
            layoutManager.updateNodeAttributes('pcDate', { "visible": true});
            // newFormData.vessel = null;
            // newFormData.terminal = null;
            // newFormData.igmNo = null;
            // newFormData.igmDate = null;
            // newFormData.pcNo = null;
            // newFormData.pcDate = null;
        } else if(bondOption?.type === "Extension"){
            layoutManager.updateNodeAttributes('igmNo', { "visible": false});
            layoutManager.updateNodeAttributes('igmDate', { "visible": false});
            layoutManager.updateNodeAttributes('pcNo', { "visible": false});
            layoutManager.updateNodeAttributes('pcDate', { "visible": false});
            // newFormData.vessel = null;
            // newFormData.terminal = null;
            // newFormData.igmNo = null;
            // newFormData.igmDate = null;
            // newFormData.pcNo = null;
            // newFormData.pcDate = null;
        }
    }
    else{
        layoutManager.updateNodeAttributes('pcNo', { "visible": false});
        layoutManager.updateNodeAttributes('pcDate', { "visible": false});
        layoutManager.updateNodeAttributes('igmNo', { "visible": true});
        layoutManager.updateNodeAttributes('igmDate', { "visible": true});
        // newFormData.vessel = null;
        // newFormData.terminal = null;
        // newFormData.igmNo = null;
        // newFormData.igmDate = null;
        // newFormData.pcNo = null;
        // newFormData.pcDate = null;
}
    return {
        layoutChanged: true,
        dataChanged: true,
        newLayout: layoutManager.getLayout(), 
        newFormData: newFormData
       
    }
};

export default bondTransactionTypeHandler;
